module.exports = __webpack_public_path__ + "img/EDS_80X30.7e759e1d.png";